"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable @typescript-eslint/no-explicit-any */
const react_1 = __importDefault(require("react"));
function useIntersectionObserver({ root, target, onIntersect, threshold = 1.0, rootMargin = '0px' }) {
    react_1.default.useEffect(() => {
        const observer = new IntersectionObserver((entries) => entries.forEach((entry) => onIntersect(entry)), {
            root: root && root.current,
            rootMargin,
            threshold
        });
        const el = target && target.current;
        if (!el) {
            return;
        }
        observer.observe(el);
        return () => {
            observer.unobserve(el);
        };
    }, [onIntersect, root, rootMargin, target, threshold]);
}
exports.default = useIntersectionObserver;
